import api from "./api";

export const getTicketBuyers = async (filter = {}) => {
  const params = {
    pageNumber: filter.pageNumber ?? 1,
    pageSize: filter.pageSize ?? 20,
    ...(filter.hubId && { hubId: filter.hubId }),
    ...(filter.eventId && { eventId: filter.eventId }),
    ...(filter.search && { search: filter.search }),
  };
  const res = await api.get("/attendee/buyers", { params });
  const data = res.data?.data;
  return {
    data: data?.data?.$values ?? data?.data ?? data?.$values ?? [],
    totalRecords: data?.totalRecords ?? 0,
    totalPages: data?.totalPages ?? 0,
  };
};